<template>
    <div>
        <headerNav title="意见及反馈详情" />
         <div  v class="mian-list" v-if="item" >
            <div v-if="item.isAnswer"><van-tag type="danger" v-if="!item.isRead">未阅</van-tag><van-tag type="success" v-else>已阅</van-tag></div>
            <div class="mian-list-mark" v-if="item.message">
                <div><span style="color:red">我的建议及反馈：</span>{{ item.message }}</div>
                <div class="mian-list-info-data-last">{{ item.creationTime }}</div>
            </div>
            <div v-if="item.isAnswer" class="mian-list-mark">
                <div v-if="item.answerContent"><span style="color:red">客服回复：</span>{{item.answerContent}}</div>
                <div class="mian-list-info-data-last">{{ item.answerTime }}</div>
            </div>
            <div class="mian-list-info-data-last"><van-tag type="danger" v-if="!item.isAnswer">未回复</van-tag><van-tag type="success" v-else>已回复</van-tag></div>

        </div>
    </div>
</template>
<script>
export default {
    data()
    {
        return {
            item:undefined,
            id:0
        }
    },
    created(){
        var query= this.$route.query;
        this.id=query.id;
        if(this.id>0)
        {
            this.queryinfo();
        }
    },
    methods:{
        queryinfo()
        {
             this.ajax.post('/api/services/app/PhoneCom/QueryIdealModel?id='+this.id).then(x=> 
             {
                 this.item=x.result;
                 if(this.item)
                {
                    if(this.item.isAnswer)
                    {
                        this.setread(this.item);
                    }
                }
             });
        },
        setread(item)
        {   
            this.ajax.post('/api/services/app/PhoneCom/SetRead?id='+item.id).then(()=> {});
        }
    }
}
</script>
<style lang="scss" scoped>
.mian-list {
  background-color: #fff;
  font-size: 12px;
  border-radius: 8px;
  margin: 10px 40px;
  padding: 5px 20px;
  box-shadow: 1px 1px 4px #c3c3c3;
  line-height: 18px;
}



.mian-list-info-data-last {
  text-align: right;
}


.mian-list-mark {
  
  padding-bottom: 5px;
  font-size: 15px;
}
</style>
